// Dependencies
import request from 'superagent';
import * as types from '../redux/constants';

const api = function api(store) {
   return function (next) {
      return function (action) {
         const user = store.getState().user;

         next(action);

         switch (action.type) {
            case types.LOGIN:
               request
                  .post(action.url)
                  .send(action.data)
                  .end((err, response) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.LOGIN_ERROR,
                           error: err,
                        });
                     }
                     if (response.body.error) {
                        console.log(response.body.error);
                        return next({
                           type: types.LOGIN_ERROR,
                           error: response.body.error,
                        });
                     } else {
                        return next({
                           type: types.LOGIN_SUCCESS,
                           user: response.body.data,
                        });
                     }
                  });
               break;

            case types.SIGNIN:
               request
                  .post(action.url)
                  .send(action.datos)
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.SIGNIN_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.SIGNIN_ERROR,
                           error: res.body.error,
                        });
                     } else {
                        return next({
                           type: types.SIGNIN_SUCCESS,
                           message: res.body.data.mensaje,
                        });
                     }
                  });
               break;

            case types.GET_CATEGORIES:
               request
                  .get(action.url)
                  .query(action.data)
                  .end((err, response) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.GET_CATEGORIES_ERROR,
                           error: err,
                        });
                     }
                     if (response.body.error) {
                        console.log(response.body.error);
                        return next({
                           type: types.GET_CATEGORIES_ERROR,
                           error: response.body.error,
                        });
                     } else {
                        return next({
                           type: types.GET_CATEGORIES_SUCCESS,
                           categories: response.body.data,
                        });
                     }
                  });
               break;

            case types.GET_PRODUCTS:
               request
                  .get(action.url)
                  .query({ categoria: action.data.id_categoria })
                  .end((err, response) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.GET_PRODUCTS_ERROR,
                           error: err,
                        });
                     }
                     if (response.body.error) {
                        console.log(response.body.error);
                        return next({
                           type: types.GET_PRODUCTS_ERROR,
                           error: response.body.error,
                        });
                     } else {
                        //console.log(response.body);
                        return next({
                           type: types.GET_PRODUCTS_SUCESS,
                           catalogo: response.body.data,
                        });
                     }
                  });
               break;

            case types.GET_HOME_PRODUCTS:
               request.get(action.url).end((err, response) => {
                  if (err) {
                     console.log(err);
                     return next({
                        type: types.GET_HOME_PRODUCTS_ERROR,
                        error: err,
                     });
                  }
                  if (response.body.error) {
                     console.log(response.body.error);
                     return next({
                        type: types.GET_HOME_PRODUCTS_ERROR,
                        error: response.body.error,
                     });
                  } else {
                     return next({
                        type: types.GET_HOME_PRODUCTS_SUCCESS,
                        data: response.body,
                     });
                  }
               });
               break;

            case types.OBTENER_CATALOGO:
               request.get(action.url).end((err, res) => {
                  if (err) {
                     console.log('Catálogo', err);
                     return next({
                        type: types.OBTENER_CATALOGO_ERROR,
                        error: err,
                     });
                  }
                  if (res.body.error) {
                     console.log(res.body.error);
                     return next({
                        type: types.OBTENER_CATALOGO_ERROR,
                        error: res.body.error,
                     });
                  } else {
                     return next({
                        type: types.OBTENER_CATALOGO_SUCCESS,
                        catalogo: res.body.data,
                     });
                  }
               });
               break;

            case types.OBTENER_CATALOGO_BUSQUEDA:
               request
                  .get(action.url)
                  .query(action.datos)
                  .query({ idCliente: 0 })
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.OBTENER_CATALOGO_BUSQUEDA_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.OBTENER_CATALOGO_BUSQUEDA_ERROR,
                           error: res.body.error,
                        });
                     } else {
                        //console.log(res.body);
                        return next({
                           type: types.OBTENER_CATALOGO_BUSQUEDA_SUCCESS,
                           catalogo: res.body.data,
                           busqueda: action.datos.busqueda,
                        });
                     }
                  });
               break;

            case types.OBTENER_DIRECCIONES:
               request
                  .get(action.url)
                  .query({ IdCliente: user.IdCliente })
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.OBTENER_DIRECCIONES_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.OBTENER_DIRECCIONES_ERROR,
                           error: res.body.error,
                        });
                     } else {
                        return next({
                           type: types.OBTENER_DIRECCIONES_SUCCESS,
                           direcciones: res.body.data,
                        });
                     }
                  });
               break;

            case types.PROCESAR_PAGO:
               request
                  .post(action.url)
                  .send(action.customer)
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.PROCESAR_PAGO_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.PROCESAR_PAGO_ERROR,
                           error: res.body.error,
                        });
                     } else {
                        //console.log(res.body);
                        return next({
                           type: types.PROCESAR_PAGO_SUCCESS,
                           redirect: res.body,
                        });
                     }
                  });
               break;
            case types.CHECK_PRICES:
               request
                  .post(action.url)
                  .send({ user: user })
                  .send({ cart: action.data })
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.CHECK_PRICES_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.CHECK_PRICES_ERROR,
                           error: res.body.error,
                        });
                     } else {
                        //console.log(res.body);
                        return next({
                           type: types.CHECK_PRICES_SUCCESS,
                           items: res.body,
                        });
                     }
                  });
               break;
            case types.CHECKOUT:
               request
                  .post(action.url)
                  .send({ user: user })
                  .send(action.data)
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.CHECKOUT_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.CHECKOUT_ERROR,
                           error: res.body.error,
                        });
                     } else {
                        //console.log(res.body);
                        return next({
                           type: types.CHECKOUT_SUCCESS,
                           pedido: res.body,
                        });
                     }
                  });
               break;

            case types.PROCESAR_CARGO:
               request
                  .post(action.url)
                  .send(action.request)
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.PROCESAR_CARGO_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.PROCESAR_CARGO_ERROR,
                           error: err,
                        });
                     } else {
                        //console.log("Datos:", res.body);
                        return next({
                           type: types.PROCESAR_CARGO_SUCCESS,
                           payment: res.body,
                        });
                     }
                  });
               break;

            case types.OBTENER_PAISES:
               request.get(action.url).end((err, res) => {
                  if (err) {
                     console.log(err);
                     return next({
                        type: types.OBTENER_PAISES_ERROR,
                        error: err,
                     });
                  }
                  if (res.body.error) {
                     console.log(res.body.error);
                     return next({
                        type: types.OBTENER_PAISES_ERROR,
                        error: res.body.error,
                     });
                  } else {
                     //console.log("Datos:", res.body);
                     return next({
                        type: types.OBTENER_PAISES_SUCCESS,
                        paises: res.body.data,
                     });
                  }
               });
               break;
            case types.OBTENER_ESTADOS:
               request
                  .get(action.url)
                  .query({ id_pais: action.id_pais })
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.OBTENER_ESTADOS_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.OBTENER_ESTADOS_ERROR,
                           error: res.body.error,
                        });
                     } else {
                        //console.log(res.body);
                        return next({
                           type: types.OBTENER_ESTADOS_SUCCESS,
                           estados: res.body.data,
                        });
                     }
                  });
               break;

            case types.OBTENER_PEDIDOS:
               request
                  .post(action.url)
                  .send({ user: user })
                  .send(action.data)
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.OBTENER_PEDIDOS_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.OBTENER_PEDIDOS_ERROR,
                           error: res.body.error,
                        });
                     } else {
                        //console.log(res.body);
                        return next({
                           type: types.OBTENER_PEDIDOS_SUCCESS,
                           pedidos: res.body,
                        });
                     }
                  });
               break;
            case types.OBTENER_PEDIDOS_LINEAS:
               request
                  .post(action.url)
                  .send({ id_factura: action.id_factura })
                  .end((err, res) => {
                     if (err) {
                        console.log(err);
                        return next({
                           type: types.OBTENER_PEDIDOS_LINEAS_ERROR,
                           error: err,
                        });
                     }
                     if (res.body.error) {
                        console.log(res.body.error);
                        return next({
                           type: types.OBTENER_PEDIDOS_LINEAS_ERROR,
                           error: res.body.error,
                        });
                     } else {
                        //console.log(res.body);
                        return next({
                           type: types.OBTENER_PEDIDOS_LINEAS_SUCCESS,
                           lineas: res.body,
                        });
                     }
                  });
               break;

            default:
               break;
         }
      };
   };
};

export async function requestApi(url, method, types, data) {
   const response = await new Promise((res, rej) => {
      res(requestMethod(url, method, types, data));
   });
   return response;
}

async function requestMethod(url, method, types, data) {
   let response = {};
   if (method === 'GET') {
      response = await request
         .get(url)
         .query(data)
         .then(res => {
            console.log(res);
            return { message: res.message, data: res.body.data };
         })
         .catch(err => {
            console.log(err);
            return { message: err.message };
         });
   }
   if (method === 'POST') {
      response = await request
         .post(url)
         .send(data)
         .then(res => {
            // console.log(res.body);
            return res.body;
         })
         .catch(err => {
            console.log(err);
            return { error: true, message: err.message };
         });
   }

   return response;
}

export default api;



// WEBPACK FOOTER //
// ./src/config/api.js